import { API_STATES } from "@/helpers";

const state = {
  skillsGetState              : API_STATES.NOT_REQUESTED,
  skillsGetError              : null,
  skillDeleteState            : API_STATES.NOT_REQUESTED,
  skillDeleteError            : null,
  skillCreateState            : API_STATES.NOT_REQUESTED,
  skillCreateError            : null,
  skills                      : [],
  skillUpdateState            : API_STATES.NOT_REQUESTED,
  skillUpdateError            : null,
  userSkillUpdating           : [],
  userSkillUpdateError        : null,
  userSkillDeleting           : [],
  userSkillDeleteSuccessError : null,
  userSkills                  : [],
  skill                       : {}
};

export default state;